import { HttpService, Query, QueryHandler, TaggedUrl, Tags } from '@skylab-shared/core';
import { CalculationMethod } from '@skylab-shared/dataModel';

export type SaleKindItem = Omit<SaleKindInternalItem, 'version'>;

type SaleKindInternalItem = {
    readonly version: string;
    readonly adjustment: boolean;
    readonly adjustmentDefaultDueDate: number;
    readonly adjustmentDefaultPaymentMethodId: number;
    readonly automaticallyAddPayment: boolean;
    readonly customTransactionLocation: string;
    readonly defaultCalculationMethod: CalculationMethod;
    readonly defaultDueDate: number;
    readonly defaultMarginSchemeId: number;
    readonly defaultPaymentMethodId: number;
    readonly name: string;
    readonly useCustomTransactionLocation: boolean;
};

export class SaleKindQuery extends Query<SaleKindItem[]> { }

export class SaleKindQueryHandlerBase implements QueryHandler<SaleKindQuery, SaleKindItem[]> {
    private static Url = TaggedUrl.join('sales/kinds', [Tags.Api]);

    public constructor(private readonly http: HttpService) { }

    public async handleAsync(_: SaleKindQuery): Promise<SaleKindItem[]> {
        const { data } = await this.http.get<{ items: SaleKindInternalItem[]; }>(SaleKindQueryHandlerBase.Url);
        return data.items.map(i => ({
            adjustment: i.adjustment,
            adjustmentDefaultDueDate: i.adjustmentDefaultDueDate,
            adjustmentDefaultPaymentMethodId: i.adjustmentDefaultPaymentMethodId,
            automaticallyAddPayment: i.automaticallyAddPayment,
            customTransactionLocation: i.customTransactionLocation,
            defaultCalculationMethod: i.defaultCalculationMethod,
            defaultDueDate: i.defaultDueDate,
            defaultMarginSchemeId: i.defaultMarginSchemeId,
            defaultPaymentMethodId: i.defaultPaymentMethodId,
            name: i.name,
            useCustomTransactionLocation: i.useCustomTransactionLocation
        }));
    }
}
